import ReferenceField from "./ReferenceField";

class ReferenceManyField extends ReferenceField {
    constructor(name) {
        super(name);
        this._type = 'reference_many';
    }
}

export default ReferenceManyField;



// WEBPACK FOOTER //
// ./app/components/common/configuration/Field/ReferenceManyField.js